import { CircularProgress, Paper, Typography as Text } from '@material-ui/core'
import React from 'react'

export default () => (
  <Paper
    style={{
      width: 400,
      height: 200,
      margin: 'auto',
      position: 'absolute',
      left: window.innerWidth/2-200,
      top: window.innerHeight/3-100,
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <CircularProgress/>
    <Text>Loading...</Text>
  </Paper>
)